/* Apple cart — vanilla AJAX qty +/- and line removal via /cart/change.js
   + recompute auto des cadeaux offerts (ajoute ET retire selon nb chargeurs)
   + toast Apple-style quand cadeaux ajustés
   + reload de la section après chaque update pour refresh totaux + économies. */
(function () {
  if (window.__appleCartInit) return;
  window.__appleCartInit = true;

  // Règle des cadeaux (corrigée par Matthias 2026-04-30) :
  //   <2 chargeurs    → 0 cadeau (Solo, pas éligible)
  //   2-3 chargeurs   → 1 cadeau (formule Duo, palier identique pour 2 et 3)
  //   4+ chargeurs    → 4 cadeaux (formule Famille, capé à 4)
  // Seuil paramétrable (section Panier → gift_from_qty) : 1 = cadeau dès le premier chargeur.
  function expectedGiftCount(n) {
    var fromQty = (window.AppleCartGift && Number(window.AppleCartGift.fromQty)) || 2;
    if (n < fromQty) return 0;
    if (n >= 4) return 4;
    return 1; // 2 et 3 chargeurs → 1 cadeau (ou 1 chargeur si seuil = 1)
  }

  // Brief #160 follow-up : whitelist STRICT 2 types pour compteur PACK CADEAU.
  // MagSafe + PopCulture retirés (arrêtés du catalogue 2026-05-18).
  // ChargerCare="Garantie", Adaptateur="Adaptateur" → exclus.
  // Aligné sur apple-cart.liquid + apple-cart-reco.liquid (whitelist serveur).
  // Critère cadeau = final_line_price === 0.
  // NB : la whitelist du sync ChargerCare orphelines (countChargersForCC) est
  // plus large — startsWith('chargeur') — un legacy MagSafe doit garder sa garantie.
  var CHARGEUR_TYPES = [
    'chargeur 3-en-1',
    'chargeur sans fil'
  ];
  // === Brief #160 follow-up — Sync ChargerCare orphelines ===
  // Règle : qty(ChargerCare) ≤ qty(chargeurs_total) à tout instant.
  // Si user supprime un chargeur, CC est cappé proportionnellement.
  // Si chargeurs_total === 0, CC entièrement retirée du cart.
  // Whitelist BROAD (startsWith 'chargeur' downcased) — un legacy MagSafe ou
  // PopCulture doit aussi compter comme support de garantie. Différent de la
  // whitelist STRICT 2 types du compteur pack cadeau (lot Duo / Famille).
  // Triggers : init (DOMContentLoaded) + après chaque updateLine.
  var CHARGERCARE_VARIANT_ID = 58060079497561;
  function countChargersForCC(cart) {
    var total = 0;
    cart.items.forEach(function (item) {
      if (item.final_line_price === 0) return; // exclure items offerts
      var pt = (item.product_type || '').toLowerCase();
      if (pt.indexOf('chargeur') === 0) {
        total += item.quantity;
      }
    });
    return total;
  }
  function reconcileChargerCare(cart) {
    var chargersTotal = countChargersForCC(cart);
    var ccLine = null;
    cart.items.forEach(function (item) {
      if (item.variant_id === CHARGERCARE_VARIANT_ID) ccLine = item;
    });
    if (!ccLine) return Promise.resolve({ cart: cart, ccChanged: false });
    if (ccLine.quantity <= chargersTotal) return Promise.resolve({ cart: cart, ccChanged: false });
    var newQty = chargersTotal; // 0 supprime la ligne CC
    console.log('[apple-cart] CC orphan sync : capping ChargerCare qty', ccLine.quantity, '→', newQty, '(chargeurs_total=' + chargersTotal + ')');
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: ccLine.key, quantity: newQty })
    })
      .then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }); })
      .then(function (newCart) { return { cart: newCart, ccChanged: true }; });
  }

  function classifyCart(cart) {
    var chargeurCount = 0;
    var giftLines = [];
    cart.items.forEach(function (item) {
      // Cadeau = ligne à 0 €
      if (item.final_line_price === 0) {
        giftLines.push({ key: item.key, qty: item.quantity, variantId: item.variant_id });
        return;
      }
      var pType = (item.product_type || '').toLowerCase();
      if (CHARGEUR_TYPES.indexOf(pType) !== -1) {
        chargeurCount += item.quantity;
      }
    });
    return { chargeurCount: chargeurCount, giftLines: giftLines };
  }

  // Trouve le variant ID du cadeau soit depuis une ligne existante, soit
  // depuis window.AppleCartGift exposé par apple-cart.liquid.
  function getGiftVariantId(cart) {
    for (var i = 0; i < cart.items.length; i++) {
      if (cart.items[i].final_line_price === 0) return cart.items[i].variant_id;
    }
    return (window.AppleCartGift && window.AppleCartGift.variantId) || null;
  }

  // Reconcile les cadeaux : ajoute si manque, retire si trop.
  // Renvoie une promise { cart, delta, expected, current } pour décider du toast.
  function reconcileGifts(cart) {
    var info = classifyCart(cart);
    var expected = expectedGiftCount(info.chargeurCount);
    var current = info.giftLines.reduce(function (s, g) { return s + g.qty; }, 0);
    var noChange = { cart: cart, delta: 0, expected: expected, current: current, chargeurCount: info.chargeurCount };

    if (current === expected) return Promise.resolve(noChange);

    if (current > expected) {
      // RETRAIT : réduit ligne par ligne via /cart/change.js séquentiel
      var toRemove = current - expected;
      var ops = [];
      for (var i = 0; i < info.giftLines.length && toRemove > 0; i++) {
        var line = info.giftLines[i];
        var newQty = Math.max(0, line.qty - toRemove);
        toRemove -= (line.qty - newQty);
        ops.push({ id: line.key, quantity: newQty });
      }
      var p = Promise.resolve(cart);
      ops.forEach(function (op) {
        p = p.then(function () {
          return fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify(op)
          }).then(function (r) { return r.json(); });
        });
      });
      return p.then(function (finalCart) {
        return { cart: finalCart, delta: expected - current, expected: expected, current: current, chargeurCount: info.chargeurCount };
      });
    }

    // AJOUT : current < expected — ajoute la quantité manquante via /cart/add.js
    var toAdd = expected - current;
    var giftVariantId = getGiftVariantId(cart);
    if (!giftVariantId) {
      console.error('[apple-cart] ❌ AUTO-ADD CADEAU IMPOSSIBLE : variant ID introuvable.\n' +
        '→ Configure le handle de ton produit cadeau dans Shopify admin :\n' +
        '   Online Store > Themes > Customize > Section "Apple · Page panier" > "Cadeau auto (reconcile)" > gift_product_handle\n' +
        '→ Handles testés (par défaut) : 3-accessoires-offerts, pack-cadeau, accessoires-offerts, cable-mfi, etc.\n' +
        '→ window.AppleCartGift =', window.AppleCartGift);
      return Promise.resolve(noChange);
    }
    console.log('[apple-cart] ✓ Auto-ajout', toAdd, 'cadeau(x), variant', giftVariantId);
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        items: [{
          id: giftVariantId,
          quantity: toAdd,
          properties: { 'Offert avec votre pack': 'Oui' }
        }]
      })
    })
      .then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }); })
      .then(function (finalCart) {
        return { cart: finalCart, delta: toAdd, expected: expected, current: current, chargeurCount: info.chargeurCount };
      });
  }

  // ---------- Toast Apple-style ----------
  function ensureToastContainer() {
    var c = document.querySelector('[data-cart-toasts]');
    if (c) return c;
    c = document.createElement('div');
    c.className = 'apple-cart-toasts';
    c.setAttribute('data-cart-toasts', '');
    document.body.appendChild(c);
    return c;
  }
  function showToast(message, duration) {
    duration = duration || 20000; // 20s par défaut
    var container = ensureToastContainer();
    var toast = document.createElement('div');
    toast.className = 'apple-cart-toast';
    // Wrap : message à gauche + croix dismissive à droite
    toast.innerHTML =
      '<span class="apple-cart-toast-msg">' + message + '</span>' +
      '<button type="button" class="apple-cart-toast-close" aria-label="' +
        ((window.LpcI18n && window.LpcI18n.closeMessage) || 'Fermer le message') +
        '">' +
        '<svg viewBox="0 0 14 14" width="14" height="14" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round">' +
          '<path d="M3 3l8 8M11 3l-8 8"/>' +
        '</svg>' +
      '</button>';
    container.appendChild(toast);
    toast.offsetHeight; // force reflow

    var hideTimer;
    function dismiss() {
      if (hideTimer) clearTimeout(hideTimer);
      toast.classList.remove('is-visible');
      setTimeout(function () { if (toast.parentNode) toast.remove(); }, 400);
    }
    toast.querySelector('.apple-cart-toast-close').addEventListener('click', dismiss);

    requestAnimationFrame(function () {
      requestAnimationFrame(function () { toast.classList.add('is-visible'); });
    });
    hideTimer = setTimeout(dismiss, duration);
  }

  // Persiste un message dans sessionStorage pour qu'il soit affiché APRÈS le
  // refresh de la section (sinon le toast peut être interrompu par le re-render
  // dans certains navigateurs ou contextes preview Shopify).
  // Matthias a constaté que le toast disparaissait en <2s alors qu'il devrait
  // durer 5s+ → racine probable : toast créé pendant que la section re-render
  // → DOM mouvement → toast lost. Solution : stockage et display post-refresh.
  function pushPendingToast(message) {
    if (!message) return;
    try {
      sessionStorage.setItem('apple-cart-pending-toast', JSON.stringify({
        msg: message,
        ts: Date.now()
      }));
    } catch (e) {}
  }
  function popAndShowPendingToast() {
    try {
      var raw = sessionStorage.getItem('apple-cart-pending-toast');
      if (!raw) return;
      sessionStorage.removeItem('apple-cart-pending-toast');
      var data = JSON.parse(raw);
      // TTL 30s : si l'utilisateur a navigué ailleurs et revient plus tard, on
      // ne lui affiche pas un message obsolète.
      if (data && data.msg && (Date.now() - data.ts) < 30000) {
        showToast(data.msg, 20000);
      }
    } catch (e) {}
  }
  function buildToastMessage(result) {
    var n = result.chargeurCount;
    var exp = result.expected;
    var delta = result.delta;
    // Logique métier : le cadeau s'attache au LOT formule, pas au nombre brut
    // de chargeurs. 2-3 chargeurs = lot Duo (1 cadeau pour le lot de 2), 4+ =
    // lot Famille (4 cadeaux pour le lot de 4). Le 3e chargeur est solo, sans
    // cadeau dédié, mais profite de l'écosystème.
    if (delta > 0) {
      if (exp === 4) {
        // Distingue : delta = N nouveaux cadeaux ajoutés (ex 3 si on partait de 1).
        // Évite "3 cadeaux offerts" qui prête à confusion (le total est 4) :
        // dit "+N cadeaux" / "N cadeaux supplémentaires" pour clarté.
        return '✦ Pack <strong>Famille</strong> débloqué. <strong>+' + delta + ' cadeau' + (delta > 1 ? 'x' : '') + '</strong> pour votre pack de 4 chargeurs.';
      }
      if (exp === 1) {
        return '✦ Pack <strong>Duo</strong> activé. 1 cadeau offert pour votre lot de 2 chargeurs.';
      }
      return '✦ Pack mis à jour. <strong>+' + delta + ' cadeau' + (delta > 1 ? 'x' : '') + '</strong> ajouté' + (delta > 1 ? 's' : '') + '.';
    }
    if (delta < 0) {
      if (exp === 0) {
        return 'Pack ajusté : il faut au moins 2 chargeurs pour un cadeau offert.';
      }
      if (exp === 4) {
        // 5+ → 4 chargeurs : passage au lot Famille pile
        return 'Pack ajusté : <strong>4 cadeaux offerts</strong> pour votre lot Famille de 4 chargeurs.';
      }
      if (exp === 1) {
        // Cas n=2 : pile lot Duo. Cas n=3 : 1 lot Duo + 1 chargeur solo (extra).
        if (n === 2) {
          return 'Pack ajusté : <strong>1 cadeau offert</strong> pour votre lot Duo de 2 chargeurs.';
        }
        return 'Pack ajusté : <strong>1 cadeau offert</strong> pour votre lot Duo de 2 chargeurs (le 3<sup>e</sup> est sans cadeau dédié).';
      }
      return 'Pack ajusté : <strong>' + exp + ' cadeau' + (exp > 1 ? 'x' : '') + ' offert' + (exp > 1 ? 's' : '') + '</strong>.';
    }
    return null;
  }

  function init() {
    var form = document.querySelector('[data-apple-cart]');
    if (!form) return;

    // Si une action panier précédente a demandé un scroll-to-top après reload
    // (ajout d'un chargeur via reco, par exemple), on remonte tout en haut du
    // panier pour que l'utilisateur voie le récap mis à jour ('Le montant total
    // de votre panier est de…') et pas l'ancienne section reco au milieu.
    try {
      if (sessionStorage.getItem('apple-cart-scroll-top') === '1') {
        sessionStorage.removeItem('apple-cart-scroll-top');
        if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
        // Délai 60ms pour laisser le DOM monter avant le scroll
        setTimeout(function () { window.scrollTo({ top: 0, behavior: 'smooth' }); }, 60);
      }
    } catch (e) {}

    function refreshCartSection() {
      var sectionId = form.closest('section[id^="shopify-section-"]');
      if (!sectionId) { window.location.reload(); return Promise.resolve(); }
      var sectionHandle = sectionId.id.replace('shopify-section-', '');
      return fetch('/cart?sections=' + encodeURIComponent(sectionHandle), {
        headers: { 'Accept': 'application/json' }
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var html = data[sectionHandle];
          if (!html) { window.location.reload(); return; }
          var tmp = document.createElement('div');
          tmp.innerHTML = html;
          var newSection = tmp.querySelector('section[id="shopify-section-' + sectionHandle + '"]') || tmp.firstElementChild;
          if (newSection) {
            sectionId.innerHTML = newSection.innerHTML;
            window.__appleCartInit = false;
            init();
          } else {
            window.location.reload();
          }
        })
        .catch(function () { window.location.reload(); });
    }

    function updateLine(line, quantity) {
      var key = line.getAttribute('data-line-key');
      line.classList.add('is-loading');
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity })
      })
        .then(function (r) { return r.json(); })
        // Brief #160 follow-up : sync CC orphelines AVANT reconcile gifts.
        // Ordre important : si user supprime 2 chargeurs, on cape d'abord CC
        // pour que reconcileGifts() recompute sur l'état post-CC-cap.
        .then(function (cart) { return reconcileChargerCare(cart); })
        .then(function (ccResult) {
          return reconcileGifts(ccResult.cart).then(function (giftResult) {
            giftResult.ccChanged = ccResult.ccChanged;
            return giftResult;
          });
        })
        .then(function (result) {
          if (result.cart.item_count === 0) {
            window.location.reload();
            return;
          }
          // Stocke le message AVANT le refresh ; popAndShowPendingToast() dans
          // init() (qui se ré-exécute après refreshCartSection) affichera le
          // toast sur le DOM stable post-refresh, pour 20s.
          if (result.delta !== 0) {
            pushPendingToast(buildToastMessage(result));
          }
          refreshCartSection();
        })
        .catch(function (err) {
          console.error('Cart update failed', err);
          line.classList.remove('is-loading');
        });
    }

    form.addEventListener('click', function (ev) {
      var stepBtn = ev.target.closest('[data-qty-step]');
      var removeBtn = ev.target.closest('[data-remove]');
      var line = ev.target.closest('.acp-line');
      if (!line) return;
      if (stepBtn) {
        var step = parseInt(stepBtn.getAttribute('data-qty-step'), 10);
        var input = line.querySelector('[data-qty-input]');
        var current = parseInt(input ? input.value : '1', 10) || 1;
        var next = Math.max(0, current + step);
        updateLine(line, next);
      } else if (removeBtn) {
        updateLine(line, 0);
      }
    });

    form.addEventListener('change', function (ev) {
      if (!ev.target.matches('[data-qty-input]')) return;
      var line = ev.target.closest('.acp-line');
      var qty = parseInt(ev.target.value, 10);
      if (isNaN(qty) || qty < 0) qty = 0;
      updateLine(line, qty);
    });

    // Expose API publique pour la section apple-cart-reco (et autres add-ons
    // qui veulent ajouter au panier avec reconcile + toast intégrés).
    window.AppleCart = window.AppleCart || {};
    window.AppleCart.addAndReconcile = function (variantId, title) {
      return window.AppleCart.addManyAndReconcile([{ variantId: variantId, title: title || 'produit' }], title);
    };
    // Ajoute plusieurs items en une seule requête /cart/add.js, puis reconcile
    // les cadeaux (si l'ajout fait passer aux conditions Duo/Famille, le toast
    // formule s'affichera après reload). Reload complet pour que les sections
    // cart + cart-reco se re-render avec les nouveaux comptages.
    window.AppleCart.addManyAndReconcile = function (itemsList, displayTitle) {
      if (!itemsList || !itemsList.length) return Promise.resolve();
      var bodyItems = itemsList.map(function (it) {
        return { id: parseInt(it.variantId, 10), quantity: parseInt(it.quantity, 10) || 1 };
      });
      var label = displayTitle || (itemsList.length > 1 ? itemsList.length + ' chargeurs' : (itemsList[0].title || 'produit'));
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: bodyItems })
      })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error('cart add failed');
          pushPendingToast('✦ <strong>' + label + '</strong> ajouté' + (itemsList.length > 1 ? 's' : '') + ' à votre panier.');
          return fetch('/cart.js').then(function (r) { return r.json(); });
        })
        .then(function (cart) { return reconcileGifts(cart); })
        .then(function (result) {
          if (result.delta !== 0) {
            var msg = buildToastMessage(result);
            if (msg) pushPendingToast(msg);
          }
          // Flag sessionStorage : init() scrollera en haut de la page après reload.
          try { sessionStorage.setItem('apple-cart-scroll-top', '1'); } catch (e) {}
          window.location.reload();
        });
    };

    // Reconcile au chargement de la page : si quelqu'un atterrit sur le panier
    // après avoir composé 2 packs séparés (donc 4 chargeurs + seulement 2
    // cadeaux), on upgrade automatiquement à 4 cadeaux et on affiche le toast.
    // Garde-fou : ne reconcile qu'une seule fois par session de cart page
    // (sinon le re-init après refreshCartSection re-déclencherait).
    // Affiche tout toast en attente (résultat d'une action précédente, refresh
     // de section, voire reload complet). Toast 20s sur DOM stable.
    popAndShowPendingToast();

    if (!window.__appleCartReconciled) {
      window.__appleCartReconciled = true;
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        // Brief #160 follow-up : sync CC orphelines au load (état corrompu
        // hérité de session précédente où chargers ont été retirés sans CC).
        .then(function (cart) { return reconcileChargerCare(cart); })
        .then(function (ccResult) {
          var cart = ccResult.cart;
          var info = classifyCart(cart);
          var expected = expectedGiftCount(info.chargeurCount);
          var current = info.giftLines.reduce(function (s, g) { return s + g.qty; }, 0);
          var giftVariantId = getGiftVariantId(cart);
          console.log('[apple-cart] reconcile init :', {
            chargeurCount: info.chargeurCount,
            cartItems: cart.items.length,
            currentGifts: current,
            expectedGifts: expected,
            delta: expected - current,
            giftVariantId: giftVariantId,
            giftAvailable: !!giftVariantId,
            ccChanged: ccResult.ccChanged,
            note: giftVariantId ? null : 'AUCUN variant ID cadeau trouvé. Settings cart > gift_product_handle vide ET aucun handle fallback ne match (3-accessoires-offerts, pack-cadeau...). Configurez gift_product_handle dans le theme editor.'
          });
          return reconcileGifts(cart).then(function (giftResult) {
            giftResult.ccChanged = ccResult.ccChanged;
            return giftResult;
          });
        })
        .then(function (result) {
          if (result.delta !== 0) {
            pushPendingToast(buildToastMessage(result));
            refreshCartSection();
          } else if (result.ccChanged) {
            // CC capée silencieusement (pas de toast pour éviter confusion).
            // Refresh nécessaire pour reflèter le nouveau total dans le DOM.
            refreshCartSection();
          }
        })
        .catch(function (err) { console.warn('[apple-cart] reconcile init failed', err); });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
